import React from "react";
import ClassComponent from "../../components/Class/Class.component";
import IPage from "../../interfaces/page"

const ClassPage: React.FunctionComponent<IPage> = (props: IPage) => {
  return <ClassComponent></ClassComponent>;
};

export default ClassPage;
